import { http } from "./client";

export const VehiclesAPI = {
  list: () => http("/vehicles"),
  create: (payload) =>
    http("/admin/vehicles", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) =>
    http(`/admin/vehicles/${id}`, { method: "PUT", body: JSON.stringify(payload) }),
  remove: (id) => http(`/admin/vehicles/${id}`, { method: "DELETE" }),
};
